var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSandsfp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512.61 1066.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\n        stroke: #000;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-3 {\n        fill: url(#radial-gradient-3);\n        filter: url(#drop-shadow-3);\n      }\n\n      .cls-4 {\n        fill: url(#radial-gradient-4);\n        filter: url(#drop-shadow-4);\n      }\n\n      .cls-7 {\n        filter: url(#AI_BevelShadow_1);\n      }\n\n      .cls-5 {\n        fill: url(#radial-gradient);\n        filter: url(#drop-shadow-1);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-6 {\n        fill: url(#radial-gradient-2);\n        filter: url(#drop-shadow-2);\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 409.82,
    cy: 312.09,
    fx: 409.82,
    fy: -87.94,
    r: 400.03,
    gradientTransform: "translate(0 -.15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#f0f0f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#bfc2c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#94989b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#707579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#53595e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#3c4348"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#2c3439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#222a30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20282e"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    x: 350.16,
    y: 0,
    width: 137.28,
    height: 1056.48,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 7,
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 245.32,
    cy: -117.78,
    fx: 245.32,
    fy: -300.82,
    r: 623.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#c1272d"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-2",
    x: 121.2,
    y: 2.88,
    width: 254.4,
    height: 1053.6,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 7,
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 78.93,
    cy: 158.69,
    fx: 78.93,
    fy: 158.69,
    r: 529.59,
    gradientTransform: "translate(0 -.05)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#ecbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#d97d81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#cc4e53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#c43137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c1272d"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-3",
    x: 0,
    y: 275.28,
    width: 174.48,
    height: 781.44,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 7,
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-3",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-3",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 212.78,
    cy: 265.37,
    fx: -18.62,
    fy: 265.37,
    r: 445.95,
    gradientTransform: "translate(609.81 52.59) rotate(90) scale(1 1.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#bbbdbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83888b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#585e63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#394046"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#262e34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20282e"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-4",
    x: 148.08,
    y: 272.88,
    width: 138.24,
    height: 783.84,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 7,
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-4",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-4",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "AI_BevelShadow_1",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    result: "blur",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4,
    in: "blur",
    result: "offsetBlur"
  }), /*#__PURE__*/React.createElement("feSpecularLighting", {
    in: "blur",
    result: "specOut",
    specularConstant: 1,
    specularExponent: 10,
    surfaceScale: 5
  }, /*#__PURE__*/React.createElement("fePointLight", {
    x: -5000,
    y: -10000,
    z: -20000
  })), /*#__PURE__*/React.createElement("feComposite", {
    in: "specOut",
    in2: "SourceAlpha",
    operator: "in",
    result: "specOut"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "specOut",
    k1: 0,
    k2: 1,
    k3: 1,
    k4: 0,
    operator: "arithmetic",
    result: "litPaint"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "offsetBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "litPaint"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 311.95,
    y1: 277.78,
    x2: 311.95,
    y2: 836.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#fbdcdd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#f6afb1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#f28a8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#ef6d71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#ed585d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#ec4c52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ec484e"
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "464.87 1033.81 358.7 1033.93 360.45 8.74 460.7 37.37 464.87 1033.81"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "352.91 1033.93 134.7 1033.93 129.84 135.27 351.7 11.76 352.91 1033.93"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "151.91 1034.06 11.7 1034.06 8.58 353.31 150.7 284.3 151.91 1034.06"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "263.58 1033.93 156.7 1034.06 158.79 281.5 259.7 302.49 263.58 1033.93"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "157.68 1033.93 152.7 1033.93 151.7 283.79 157.87 281.63 157.68 1033.93"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "359.57 1033.93 352.68 1033.93 352.68 11.27 359.45 8.8 359.57 1033.93"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M224.72,939.75c16.55-20.19,24.62-46.94,42.78-66,25.52-27.42,55.93-55.62,84.11-81.72,2.98-2.6,8.58-7.63,11.42-7.44.86,0,1.47.43,1.84,1.19,1.85,4.53-2.26,19.51,7.61,19.34,73.6-17.97,107.02-117.74,61.58-177.07-8.48-10.72-34.1-47.08-48.68-45.23-5.78,5.52,3.73,18.83,6.51,25.03,9.06,16.15,13.33,32.39,12.09,51.64-.03,3.83-2.04,27.22-7.56,16.6-27.99-112.99-165.84-232.7-76.17-342.63,11.13-12.83,21.66-29.82-6.16-20.18-49.8,17.1-83.68,66.9-79.6,117.04-.04,3.23,1.15,11.34-.3,12.86-.39.32-.95-.07-1.64-1.14-2.12-3.54-3.57-8.29-4.76-12.55-3.51-10.05-3.84-45.79-17.37-30.79-12,20.51-14.14,58.91-15.47,82.18-11.43,116.56,144.36,158.46,99.91,264.72-4.18,6.22-4.46-7.76-4.86-11.39.66-56.56-51.93-88.29-86.01-126.69-8.48-8.9-14.51-20.17-19.74-30.88-5.4-11.4-13.75-15.81-15.1.35-.58,103.39,112.83,153.15,67.19,275.15-3.56,15.24-7,30.43-9.96,45.84-2.85,14.63-5.8,28.63-2.03,41.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M224.72,939.75c16.55-20.19,24.62-46.94,42.78-66,25.52-27.42,55.93-55.62,84.11-81.72,2.98-2.6,8.58-7.63,11.42-7.44.86,0,1.47.43,1.84,1.19,1.85,4.53-2.26,19.51,7.61,19.34,73.6-17.97,107.02-117.74,61.58-177.07-8.48-10.72-34.1-47.08-48.68-45.23-5.78,5.52,3.73,18.83,6.51,25.03,9.06,16.15,13.33,32.39,12.09,51.64-.03,3.83-2.04,27.22-7.56,16.6-27.99-112.99-165.84-232.7-76.17-342.63,11.13-12.83,21.66-29.82-6.16-20.18-49.8,17.1-83.68,66.9-79.6,117.04-.04,3.23,1.15,11.34-.3,12.86-.39.32-.95-.07-1.64-1.14-2.12-3.54-3.57-8.29-4.76-12.55-3.51-10.05-3.84-45.79-17.37-30.79-12,20.51-14.14,58.91-15.47,82.18-11.43,116.56,144.36,158.46,99.91,264.72-4.18,6.22-4.46-7.76-4.86-11.39.66-56.56-51.93-88.29-86.01-126.69-8.48-8.9-14.51-20.17-19.74-30.88-5.4-11.4-13.75-15.81-15.1.35-.58,103.39,112.83,153.15,67.19,275.15-3.56,15.24-7,30.43-9.96,45.84-2.85,14.63-5.8,28.63-2.03,41.74"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandsfp);
export default __webpack_public_path__ + "static/media/sandsfp.a36c14d834969f46f2ea43e9f38f1476.svg";
export { ForwardRef as ReactComponent };